import type Localiser from '../../../../core/modules/Localiser';
import type { Site } from '../../../../core/modules/sites/Site';
import type { PlatformData } from '../../../../core/types/PlatformData';
import { HawkEvents } from '../../../../types/HawkEvents';
import { WIDGET_PLACEHOLDER_SELECTOR } from '../../../../utils/constants';
import { getNodes } from '../../../utils/getNodes';

import { resolveWidgets } from './resolveWidgets';

interface ArticleConfig {
  site: Site;
  localiser: Localiser;
  editorialOnPage: boolean;
  platformData: PlatformData;
}

/**
 *  Listen for dynamically added widgets. Used mainly in infinite scroll articles
 *  (https://www.windowscentral.com/gaming/nacon-launch-rig-600-pro-dual-wireless-gaming-headset).
 */
export const handleInfiniteScrollArticles = (config: ArticleConfig): void => {
  const { site, localiser, editorialOnPage, platformData } = config;
  document.addEventListener(
    HawkEvents.HAWK_PROCESS_ARTICLE,
    async (
      event: CustomEventInit<{
        element?: HTMLElement;
      }>,
    ) => {
      const unprocessedWidgets = getNodes({
        selector: WIDGET_PLACEHOLDER_SELECTOR,
        context: event.detail?.element,
      });
      resolveWidgets({
        unprocessedWidgets,
        site,
        localiser,
        editorialOnPage,
        platformData,
      });
    },
  );
};
